import { render, staticRenderFns } from "./Pinwheel.vue?vue&type=template&id=67b9a85f"
import script from "./Pinwheel.vue?vue&type=script&lang=js"
export * from "./Pinwheel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports